// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wnsbq","option":"styles_option__OyJMS","active":"styles_active__3x3OX"};